<template>
    <section>

        <div class="page">
            <div>
                <h2>Is it free to send messages over ToTok?</h2>
                <p>ToTok uses your phone's Internet connection (4G/3G/2G/EDGE or Wi-Fi, as available) to send and
                    receive messages
                    to your friends and family. You don't have to pay for every message. As long as you haven't exceeded
                    your data
                    limit or you're connected to a free Wi-Fi network, your carrier shouldn't charge you extra for
                    messaging over
                    ToTok. </p>
                <p>ToTok Calling works in the same way.</p>
                <h3>Please be aware that:</h3>
                <ul>
                    <li>If your phone is <strong>roaming</strong>, additional mobile data charges may apply.</li>
                    <li>If you send SMS messages to your friends inviting them to use ToTok, service charges from your
                        mobile provider
                        may also apply.
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
